import script from "./BasketTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BasketTable.vue?vue&type=script&setup=true&lang=js"

import "./BasketTable.vue?vue&type=style&index=0&id=6d7ba02a&scoped=true&lang=scss"
import "./BasketTable.vue?vue&type=style&index=1&id=6d7ba02a&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d7ba02a"]])

export default __exports__